<script>
    export default {
        mounted() {
			$(this.$el).popup({
				position : 'bottom left'
			});
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UiPopup.vue